<template>
  <div class="news-details">
    <HeaderNav :current="current" :titleMsg='titleMsg'></HeaderNav>
    <div class="news-content w1200">
      <div class="text">
        <!-- <p>首页/新闻</p> -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'FocussList'}"><a href="javascript:void(0);">医疗与反兴奋剂</a></el-breadcrumb-item>
          <el-breadcrumb-item>医疗与反兴奋剂详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- <h2 class="clum">
        <i class="icon">活动信息</i>
      </h2> -->
      <div class="action-msg" v-loading="loading" element-loading-text="加载中"  >
        <div class="left-warp">
          <div class="details-title">
            <p>{{newDetails.title}}</p>
            <p>{{newDetails.subTitle}}</p>
            <p>浏览数量：{{newDetails.view}}</p>
          </div>
          <div class="video" v-if="newDetails.videoUrl">
            <video controls :src="newDetails.videoUrl"></video>
          </div>
          <div class="content w-e-text" ref="content" v-html="newDetails.content"></div>
        </div>
        <div class="right-list">
          <div class="hote">
            <h2 class="clum">
              <i class="icon">热点新闻</i>
            </h2>
            <div class="hot-item" v-for="(item,index) in list" :key="index" @click="addNewsDetails(item)">
              <div class="cover">
                <img :src="item.conver" alt="">
              </div>
              <div class="hot-content">
                <p class="title">{{item.title}}</p>
                <p class="subtitle">{{item.subTitle}}</p>
                <p class="time">{{formatDate(item.issueTime,true)}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BackTop></BackTop>
    <CopyRight></CopyRight>
  </div>
</template>

<script>
import { websiteNewsDetail, websitePageNews } from '@/api/association'
import BackTop from '@/components/common/BackTop/BackTop'
import HeaderNav from '@/components/common/HeaderNav/HeaderNav'
import CopyRight from '@/components/common/CopyRight/CopyRight'
import {formatDate} from '@/components/common/config/formatTime.js'
export default {
  name: 'tabs',
  components: {
    HeaderNav,
    CopyRight,
    BackTop
  },
  data () {
    return {
      current: 6,
      titleMsg: '医疗与反兴奋剂详情',
      newDetails: {},
      loading: false,
      list: [],
      pageNum: 1,
      newsId: '',
      sliderStyle: {
        width: '100%'
      }
    }
  },
  methods: {
    formatDate,
    addNewsDetails (item) {
      let that = this
      let nweId = ''
      if (item) {
        nweId = item.id
      } else {
        nweId = that.$route.query.newsId
      }
      that.loading = true
      websiteNewsDetail({ newsId: nweId }).then(res => {
        that.loading = false
        if (res.data.status === 0) {
          that.newDetails = res.data.data
          that.$nextTick(function () {
            that.reverPptUrl()
          // Code that will run only after the
          // entire view has been rendered
          })
        }
      }).catch((res) => {
        that.loading = false
        // hideLoading()
        that.$message.warning('网络错误')
      })
      // that.loading = true
    },
    addNewList () {
      let that = this
      websitePageNews({ pageNo: 1, pageSize: 5, assoId: localStorage.getItem('assoId'), type: 5 }).then(res => {
        if (res.data.status === 0) {
          that.list = res.data.data.list
        }
      })
      // that.loading = true
    },
    // ppt添加缩略图样式
    reverPptUrl: function () {
      let pptArr = this.$refs.content.getElementsByTagName('img')
      if (pptArr.length > 0) {
        console.log(pptArr.length)
        for (let i = 0; i < pptArr.length; i++) {
        // let pptEl = pptArr[i].src
          let NewPptUrl = 'width:100%;display:block;'
          pptArr[i].setAttribute('style', NewPptUrl)
        // console.log(NewPptUrl)
        }
      }
    },
    enterNewsList () {
      this.$router.push({
        name: `NewList`,
        params: { type: this.type }
      })
    }
  },
  mounted () { // 这里必须是mouted钩子
  },
  created () {
    this.addNewsDetails()
    this.addNewList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .news-details {
    width: 100%;
    background-color: #fff;
  }

  .news-content {
    width: 1100px;
    padding: 20px 50px 20px 50px;
    background: #f3f3f3;
    border-radius: 10px;
    margin-top: 20px;
  }

  .clum {
    overflow: hidden;
    padding: 35px 0px;
  }

  .clum .icon {
    float: left;
    font-size: 24px;
    font-weight: bold;
    background-position: 0px center;
    background-repeat: no-repeat;
    background-size: 5px 24px;
    background-image: url(../../../static/images/nwe-shuxian.png);
    padding-left: 14px;
    font-style: normal;
  }

  .clum span {
    float: right;
    font-size: 16px;
    color: #888;
    line-height: 30px;
    cursor: pointer;
  }
  .text {
    border-radius: 5px;
    background: #fff;
    margin-top: 30px;
    padding: 20px 10px;
    border-bottom: 1px solid #f6f6f6;
  }
  .text p {
    font-size: 14px;
    color:#888;
    padding: 15px;
  }
  .action-msg{
    width: 100%;
    display: flex;
    justify-content: space-between;
    min-height: 600px;
  }
  .right-list{
    width: 370px;
  }
  .right-list .clum{
    padding: 10px 0px;

  }
  .right-list .clum .icon{
    font-size: 16px;
    background-size:3px 16px;
  }
  .left-warp {
    width: 700px;
    background: #fff;
    padding: 0px 10px;
  }
  .left-warp .content img{
    display: block;
    width: 100%!important;
  }
  .details-title{
    width: 100%;
    text-align: left;
    padding: 10px 0px;
  }
  .details-title p:first-child{
    font-size: 16px;
    color:#333;
    font-weight: bold
  }
  .details-title p:nth-child(2){
    font-size: 14px;
    color:#666;
    margin-top: 5px;
  }
  .details-title p:nth-child(3){
    font-size: 12px;
    color:#999;
    margin-top: 5px;
  }
  .video {
    width: 100%;
    margin-bottom: 10px;

  }
  .video video{
    display: block;
    width: 100%;
  }
  .hote{
    background: #fff;
    padding: 10px 10px;
  }
  .hot-item {
    /* margin: 10px 0px; */
    display: flex;
    padding: 10px 0px;
    align-items: center;
    cursor:pointer;
    border-bottom: 1px solid #f3f3f3;
  }

  .hot-item .cover{
    width: 107px;
    height: 60px;
    margin-right: 10px;
  }
  .hot-item .cover img{
    display: block;
    width: 107px;
    height: 60px;
  }
  .hot-content{
    width:calc(100% - 150px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hot-content .subtitle{
    color: #555;
    font-size: 14px;
  }
  .hot-item p {
    font-size:16px;
    color:#1a1919;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hot-item p:last-child{
    font-size: 14px;
    color:#999;
  }
  .hot-item span{
    color: #999;
    font-size: 14px;
  }
  .hot-item:last-child {
    border-bottom: 0px;
  }

  .reset-border {
    border-left: 0px;
  }

  .left-list .item-top {
    text-align: center;
  }

  .left-list .item-top img {
    width: 82px;
    height: 82px;
    display: block;
    margin: 0px auto;
  }

  .left-list .item-top span {
    font-size: 16px;
    color: #1a1919;
    line-height: 42px;
    display: block;
  }

  .left-list .score {
    font-size: 14px;
    padding: 0px 20px;
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -o-box-sizing: border-box;
    -ms-box-sizing: border-box;
    box-sizing: border-box;
  }

  .list-item .score .left {
    float: left;
  }

  .list-item .score .right {
    float: right;
  }

  .list-item .score span {
    font-size: 14px;
    color: #060606;
  }

  .list-item .score i {
    font-style: normal;
    color: #fe0000;
  }

  .tabs-item .icon {
    width: 46px;
    height: 46px;
    margin: 0px auto;
    display: block;
    background-position: 0px 0px;
    background-repeat: no-repeat;
    background-size: 46px 46px;
  }

  .tabs-item span {
    font-size: 22px;
    color: #1e1e1e;
    margin-top: 20px;
    display: inline-block;
  }

  .tabs-item .icon1 {
    background-image: url(../../../static/images/zhengshu_icon.png);
  }

  .tabs-item .icon2 {
    background-image: url(../../../static/images/huiyuan_icon.png);
  }

  .tabs-item .icon3 {
    background-image: url(../../../static/images/xiehuijianjie_icon.png);
  }

  .scale {
    width: 304px;
    height: 226px;
    border: 2px solid #e8e5e5;
    margin-top: 0px;
    margin-bottom: 4px;
  }

  .scale .item-top img {
    width: 104px;
    height: 104px;
  }

  .scale .item-top span {
    font-size: 18px;
    line-height: 44px;
    border-bottom: 1px solid #e6e6e6;
    width: 276px;
    margin: 0px auto 10px auto;
  }

  .scale .score {
    margin-top: 10px;
    padding: 0px 40px;
  }

  .scale .score span {
    font-size: 16px;
    padding: 21px 0px;
  }

</style>



// WEBPACK FOOTER //
// src/components/AntiDoping/AntiDopingDetails.vue